/**
 * Dispatched by peri-tray when the tray assembly build view is active in the host,
 * so periverse can hide the top header and full-bleed the assemble-tray area.
 */
export const TRAY_ASSEMBLY_HOST_CHROME_EVENT =
  'periverse:tray-assembly-host-chrome' as const;

export type TrayAssemblyHostChromeDetail = {
  active: boolean;
};
